import React from 'react';
import styled from 'styled-components';

import LanguageDropdown from '@domain/language-dropdown';
import { useVismaConfiguration } from '@services/visitor-management';

import Image from './image';

export const PageBackground = styled.div`
  background: ${({ theme }) => theme.primary};
  min-height: 100%;
  width: 100%;
  overflow-y: auto;
`;

const Header = styled.div`
  padding: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 768px) {
    padding: 18px;
  }
`;

const LogoImage = styled.div`
  img {
    height: 100px;
    width: auto;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    img {
      height: 60px;
    }
  }
`;

function PageHeader() {
  const { configuration } = useVismaConfiguration();
  const featuredImageId = configuration?.login?.featured_image?.id as
    string | undefined;

  return (
    <Header>
      {featuredImageId ? (
        <LogoImage>
          <Image id={featuredImageId} alt="logo" />
        </LogoImage>
      ) : (
        <div />
      )}
      <LanguageDropdown locales={configuration?.locales} />
    </Header>
  );
}

export default PageHeader;
